import { useLayoutEffect, useState } from 'react';

export const useClientWidth = (): number => {
	const [width, setWidth] = useState<number>(
		typeof window !== 'undefined' ? window.innerWidth : 0
	);
	const handler = () => setWidth(window.innerWidth);
	useLayoutEffect(() => {
		const setMeasuredWidth = () => {
			handler();
		};
		window.addEventListener('resize', setMeasuredWidth);
		return () => window.removeEventListener('resize', setMeasuredWidth);
	}, []);
	return width;
};
